import dynamic from "next/dynamic";
import React from "react";

import InteractiveGraphControllerProvider from "../components/graph/InteractiveGraphControllerProvider";
import LandingDescription from "../components/get-route/LandingDescription";
import GDataLoadingGuard from "../components/graph/GDataLoadingGuard";
import GDataBaseProvider from "../components/graph/GDataBaseProvider";
import BaseLayout from "../components/layout/BaseLayout";
import ShortestPathInput from "../components/get-route/ShortestpathInput";
import { ShortestPathGraphProvider } from "../components/get-route/ShortestPathGraphProvider";
import SelectedPathGuard from "../components/get-route/SelectedPathGuard";
import PageHeader from "../components/general/PageHeader";



const InteractiveGraph = dynamic(() => import("../components/graph/InteractiveGraph"), {
    ssr: false,
});

const GraphInfoBox = dynamic(() => import("../components/get-route/graphInfoBox/GraphInfoBox"), {
    ssr: false
})



export default function GetRoute() {
    return (

        <BaseLayout pageTitle="Shortest path">
            <GDataBaseProvider>
                <PageHeader
                    title="Shortest path"
                    description="Find the shortest path in the Lightning Network."
                />

                <section>

                    <GDataLoadingGuard>

                        <InteractiveGraphControllerProvider>
                            <ShortestPathGraphProvider>
                                <div className="mt-24">
                                    <ShortestPathInput></ShortestPathInput>

                                </div>
                                <SelectedPathGuard>
                                    <div className="mt-4 row">
                                        <div className="">
                                            <GraphInfoBox></GraphInfoBox>
                                        </div>
                                        <div className="">
                                            <InteractiveGraph nodesClickable={false}></InteractiveGraph>
                                        </div>
                                    </div>
                                </SelectedPathGuard>
                            </ShortestPathGraphProvider>
                        </InteractiveGraphControllerProvider>

                    </GDataLoadingGuard>

                </section>
                <section className="mt-32">
                    <LandingDescription></LandingDescription>
                </section>

            </GDataBaseProvider>
        </BaseLayout>
    );
}
